export default __webpack_public_path__ + "img/magistrate.7aa1ee7d.png";